import { useState } from 'react'
import { useFormik } from 'formik'
import DefaultButton from '../../Button/Button'
import NewsletterService from '../../../api/newsletter-service'
import { newsletterSchema } from '../../../validations/newsletter'
import { showToast } from '../../../utils/toast'

const NewsLetterBtn = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: newsletterSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true)
      try {
        const res = await NewsletterService.subscribe({ email: values.email })
        showToast({
          title: 'Subscribed',
          description: res.message || 'Subscribed to newsletter successfully',
          status: 'success',
        })
        resetForm()
      } catch (err: any) {
        showToast({
          title: 'Subscription failed',
          description: err?.message || 'An unexpected error occurred',
          status: 'error',
        })
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl">
      <div className="rounded-full border border-gray-300 flex items-center bg-[#E1E4E7] pl-6">
        <input
          type="email"
          name="email"
          placeholder="Enter email address"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled={isSubmitting}
          className="bg-transparent outline-none border-none focus:outline-none focus:ring-0 border w-full text-black"
        />
        <div className="ml-auto">
          <DefaultButton
            type="submit"
            borderRadius="full"
            paddingY={{ base: 2, md: 6, lg: 6 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Subscribing...' : 'Get started'}
          </DefaultButton>
        </div>
      </div>
      {formik.touched.email && formik.errors.email && (
        <p className="text-red-500 text-sm mt-1 pl-6">{formik.errors.email}</p>
      )}
    </form>
  )
}

export default NewsLetterBtn
